import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/oJzZyLsn6a9iRt9Vje95Re/heylloyd-image-1775319092938.png',
  alt: 'Landing page — Law & Business Consulting'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vh7NQfPbMkkM4HogEUPe7T/heylloyd-image-1775320537591.png',
  alt: 'Landing page — Health & Wellness'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jkiwamXUMckEwHVaetXbb6/heylloyd-image-1775319264203.png',
  alt: 'Landing page — Luxury Fashion Boutique'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/34fLtRZZEJNLsVUihgGMC6/heylloyd-image-1775320767743.png',
  alt: 'Landing page — Restaurant & Dining'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3b26iye5CSTniZUqsgG7jt/heylloyd-image-1775319943195.png',
  alt: 'Landing page — Latina Notary Professional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kkLQnNgKWp15ThavDQXsnw/heylloyd-image-1775094100637.png',
  alt: 'Landing page — Premium Coaching'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iEUnjmhDzfzkqQnpL2x9vh/heylloyd-image-1775325605592.png',
  alt: 'Landing page — Luxury Real Estate Miami'
}];
// Duplicate for seamless infinite loop
const duplicatedImages = [...images, ...images];
export function PortfolioSection() {
  return <section className="py-24 bg-[#F6EFEA] overflow-hidden" data-id="element-268">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-16" data-id="element-269">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-270">
          <h2 className="text-3xl md:text-4xl font-serif text-[#3A2558] mb-4" data-id="element-271">
            Cada negocio merece una presencia digital
            que&nbsp;lo&nbsp;represente.
          </h2>
          <p className="text-lg text-gray-600 font-light max-w-2xl mx-auto" data-id="element-272">
            Una landing page no es solo una página bonita. Es tu vendedor
            disponible las&nbsp;24&nbsp;horas. Así es
            como&nbsp;la&nbsp;construimos.
          </p>
          <div className="w-24 h-1 bg-[#C9B3FF] mx-auto rounded-full mt-6" data-id="element-273"></div>
        </motion.div>
      </div>

      {/* Infinite scrolling carousel */}
      <div className="relative group" data-id="element-274">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-r from-[#F6EFEA] to-transparent z-10 pointer-events-none" data-id="element-275"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 bg-gradient-to-l from-[#F6EFEA] to-transparent z-10 pointer-events-none" data-id="element-276"></div>

        <div className="flex gap-8 animate-scroll" style={{
        width: 'max-content',
        willChange: 'transform'
      }} data-id="element-277">
          {duplicatedImages.map((img, i) => <div key={i} className="flex-shrink-0 w-[320px] sm:w-[420px] md:w-[520px] lg:w-[600px] transition-transform duration-500 hover:scale-[1.03]" data-id="element-278">
              <div className="rounded-2xl overflow-hidden shadow-lg shadow-[#3A2558]/10 border border-white/60 bg-white" data-id="element-279">
                <img src={img.src} alt={img.alt} className="w-full h-auto object-cover" draggable={false} data-id="element-280" />
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}